module.exports = __webpack_public_path__ + "static/img/2.d95f273.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-trans-terrestre-carga/2.png
// module id = 9K0+
// module chunks = 0